import { render, staticRenderFns } from "./ReviewTabComplete.vue?vue&type=template&id=66d4831a&"
import script from "./ReviewTabComplete.vue?vue&type=script&lang=js&"
export * from "./ReviewTabComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports